import React from "react";
import './VideoBanner.css';

function VideoBanner() {
    return (
        <div className="video-banner">
            <video
                className="video-banner-video"
                src="assets/img/video.mp4" // Ruta del video
                autoPlay
                loop
                muted
                playsInline
            ></video>
            <div className="video-banner-overlay"></div>
        </div>
    );
}

export default VideoBanner;